import { gql } from '@apollo/client';

export const UPDATE_ACCREDITED_INVESTOR = gql`
  mutation UpdateIsAccredited($is_accredited: Boolean) {
    editInvestmentInfo(isAccredited: $is_accredited) {
      ok
    }
  }
`;

export const UPDATE_NET_WORTH_AND_VALUE = gql`
  mutation EditNetWorth($net_worth: String, $net_worth_value: Int) {
    editInvestmentInfo(netWorth: $net_worth, netWorthValue: $net_worth_value) {
      ok
    }
  }
`;

export const UPDATE_ANNUAL_INCOME_AND_VALUE = gql`
  mutation EditAnnualIncome($annual_income: String, $annual_income_value: Int) {
    editInvestmentInfo(
      annualIncome: $annual_income
      annualIncomeValue: $annual_income_value
    ) {
      ok
    }
  }
`;

export const UPDATE_SOURCE_OF_FUNDS = gql`
  mutation EditHowWillFund($how_will_you_fund: String) {
    editInvestmentInfo(howWillYouFund: $how_will_you_fund) {
      ok
    }
  }
`;

export const UPDATE_RISK = gql`
  mutation EditAdventurousType($adventurous_type: String) {
    editInvestmentInfo(adventurousType: $adventurous_type) {
      ok
    }
  }
`;
